
(function () {
    function DICheckout() {
      "use strict";  
      var context = this;
      var mainScope = window.DI;
      context.name = "Checkout";  
      context.init = function () {
        context.endpoint = window.DI.CompanyStatic.ApiMethod;
        mainScope.DI.subscribeDOMLoaded(function () {
         
        });
      };
    context.calculateorder = function () {
      $.ajax({
        type: 'get',
        url: '/cart.js',
        success: function (data) {
          var cart = JSON.parse(data);
          var Details = [];
          console.log('cart', cart);
          cart.items.forEach(element => {
            Details.push({
              "CurrencyCode": "USD",
              "ItemCode": element.properties.discoitemid,
              "IskitItem": element.properties.isKitItem == "true" ? true : false,
              "Quantity": parseInt(element.quantity, 10)
            });
          });
          var form = document.querySelector("form[name='contactinfo']");
          var data = collectFormData(form);
          console.log("Aassa");
          if (data) {
            var request = {
              "Address1": data["shippingAddress[address]"],
              "Address2": data["shippingAddress[apartment]"],
              "Address3": "",
              "CartId": "",
              "City": data["shippingAddress[city]"],
              "Country": data["shippingAddress[country]"] || "US",
              "CouponCodes": [],
              "CurrencyCode": "USD",
              "ShipMethodID": $("input[name='shipmethod']:checked").val() || 0,
              "StoreID": 0,
              "PriceTypeID": sessionStorage.getItem('customerType') || 2,
              "CustomerId": 0,
              "CustomerType": sessionStorage.getItem('customerType') || 2,
              "Details": Details,
              "OrderType": 1,
              "State": data["shippingAddress[state]"],
              "Zip": data["shippingAddress[zip]"],
              "Language": "en"
            };
            $.ajax({
              url: 'http://shopifyapi.cloveritservices.com/api/siorder/calculateorder',
              method: "post",
              contentType: "application/json; charset=utf-8",
              data: JSON.stringify(request),
              async: true,
              success: function (response, request, trigger) {
                try {
                  $('.ss-loading').hide();

                  if (trigger.status === 200 && response.Data) {
                    var data = response.Data;
                  }
                } catch (e) {

                }
              }
            });
          }
        },
        error: function () {
        }
      });
    };
    context.getpaymenttype = function () {
      $.ajax({
        url: context.endpoint['Payment']['GetPaymentType']+'?CustomerID=0&Country=US&State=ut',
        method: "Get",
        contentType: "application/json; charset=utf-8",
        async: true,
        success: function (response, request, trigger) {
          try {
            if (trigger.status === 200) {
              bindpayment(response.Data.Data);
            } else {
            }
          } catch (e) {
          }
        }
      });

    };
    
    context.getPaymentData = function (paymentData) {
      var associateID = window.AssociateID > 0 ? window.AssociateID : 0;
      $.ajax({
        url: context.endpoint['Payment']['GetHostedPaymentData']+'?iframeId=dsIframe&merchantId=' + paymentData + '&countryCode=US&associateId=' + associateID,
        method: "Get",
        contentType: "application/json; charset=utf-8",
        async: true,
        success: function (response, request, trigger) {
          try {
            $('.ss-loading').hide();
            if (trigger.status === 200) {
              openiframe(response.Data);
            } else {
              //LoaderRemove
            }
          } catch (e) {
            $('.ss-loading').hide();
            //LoaderRemoveconsole.error("Fetching available shipping methods failed! " + e);
          }
        }
      });
    };
    context.PlaceOrder = function (request) {
      return $.ajax({
        url: context.endpoint["Order"]["CreateOrder"],
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data:JSON.stringify(request)
      });
    };
    return this;
  }
  var DICheckoutInstance = new DICheckout();
  window.DIMainInstance.injectReference(DICheckoutInstance.name, DICheckoutInstance);
  DICheckoutInstance.init();

  function runExternalScripts(urlArray, deferred) {
    deferred = deferred || $.Deferred();

    var firstScript = urlArray.splice(0, 1)[0];

    if (!firstScript) {
      deferred.resolve();
      return deferred.promise();
    }

    $.getScript(firstScript).done(function () {
      runExternalScripts(urlArray, deferred).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise();
  }
  function getExternalScripts(html) {
    var externalScriptOpenRegex = /<script[^>]*src="[^"]*"[^>]*>/g;
    var srcAttrRegex = /src="([^"]*)"/;

    var scriptTags = html.match(externalScriptOpenRegex);

    if (!scriptTags) {
      return [];
    }

    return scriptTags.map(function (tag) {
      var link = srcAttrRegex.exec(tag);

      if (!link) {
        return null;
      }

      // Index 1 is the first capture group result
      return link[1];
    }).filter(function (link) {
      return !!link;
    });
  }

  function getInlineScripts(html) {
    var inlineScriptTagRegex = /<script[^>]*>([\s\S]*)<\/script>/g;
    var scriptTags = html.match(inlineScriptTagRegex);

    if (!scriptTags) {
      return [];
    }

    return scriptTags.map(function (tag) {
      var script = inlineScriptTagRegex.exec(tag);

      if (!script) {
        return null;
      }

      // Index 1 is the first capture group result
      return script[1];
    }).filter(function (script) {
      return !!script;
    });
  }

  function removeExternalScriptTags(html) {
    var externalScriptRegex = /<script[^>]*src="[^"]*"[^>]*>.*<\/script>/g;
    return html.replace(externalScriptRegex, '');
  }



  function runInlineScripts(scriptArray) {
    window.eval(scriptArray.join('\n;\n'));
    if (typeof onload !== 'undefined' && typeof onload == 'function') { onload(); }
  }
  function executePaymentScripts(html) {
    // Extract, load and execute <script src> tags
    // Extract and execute <script> tags with inline javascript

    var externalScripts = getExternalScripts(html);
    html = removeExternalScriptTags(html);

    runExternalScripts(externalScripts).then(function () {
      var inlineScripts = getInlineScripts(html);
      runInlineScripts(inlineScripts);
    });
  }
  function openiframe(data) {
    window.AssociateID = data.AssociateID;
    setUpIframeMethods();
    executePaymentScripts(data.Head);
    var element = $('#paymentModal');
    element.show();
    element.addClass("show");
    element.find('iframe#iframDSPayment').attr('src', data.IFrameURL);
    element.find('iframe#iframDSPayment').attr('width', data.Width);
    element.find('iframe#iframDSPayment').attr('height', data.Height);
  }

})();